// @flow

import type { Node } from "react";
import React from "react";
import Col from "react-bootstrap/Col";

import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem, RenderChildrenFn } from "@/utils/JsonPageRenderer/types";

interface ColumnPageItem extends PageItem {
    props: {
        [string]: any,
        className?: string,
    };
}

/**
 * Transforms a ColumnPageItem into a bootstrap col node.
 */
class ColumnRenderer implements ItemRenderer<ColumnPageItem> {
    render(
        context: JsonPageRenderer,
        item: ColumnPageItem,
        renderChildren: RenderChildrenFn,
    ): Node {
        return (
            <Col
                key={item.id}
                className={item.props.className}
                xs={item.props.xs}
                sm={item.props.sm}
                md={item.props.md}
                lg={item.props.lg}
                xl={item.props.xl}
            >
                {renderChildren(item.children)}
            </Col>
        );
    }

    match(item: PageItem): ColumnPageItem | null {
        if (item.type === "column") {
            return item;
        }
        return null;
    }
}

export default ColumnRenderer;
